module.exports = __webpack_public_path__ + "media/images/favicon/mstile-70x70-970e12dbe84e0f106a0b20fe6d6fd3ed.png";